<template>
	<div class="menu_box border_bottom_dashed" style="border-top: none;border-bottom: none;">
		<div class="flex borderBottomDashed paddingAll20 ">
			<div class="title_shaixuan flex_jc_center">综合筛选</div>
			<div>
				<el-form :inline="true" :model="formData" class="demo-form-inline">
					<el-form-item class="select-input">
						<el-select size="small" v-model="formData.workyear" placeholder="工龄">
							<el-option v-for="(item, index) in data.workAge" :key="index" :label="item.desc" :value="item.type">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item class="select-input">
						<el-select size="small" v-model="formData.level" placeholder="专业职级">
							<el-option v-for="(item, index) in data.proficiency" :key="index" :label="item.desc" :value="item.type">
							</el-option>
						</el-select>
					</el-form-item>
				</el-form>
			</div>
		</div>
	</div>
</template>

<script>
  import { apiWorker } from "@/api/apiWorker"
	export default {
		name: "workyearAndLevel",
    data() {
      return {
        data:{},
        formData:{
          workyear:'',
          level:''
        }
      }
    },
    watch:{
      'formData.workyear':function (v){
        let obj=this.data.workAge.filter(d=>d.type==v);
        if(v!==''&&obj.length){
          this.send(obj[0],'workyear')
        }
      },
      'formData.level':function (v){
        let obj=this.data.proficiency.filter(d=>d.type==v);
        if(v!==''&&obj.length){
          this.send(obj[0],'level')
        }
      },
    },
    created() {
		  this.getClassification()
    },
    methods: {
      /** @name 获取分类数据 */
      async getClassification() {
        if(!this.$store.state.HC_workyearAndLevel){
          let res = await apiWorker.getSelect()
          this.data = res.data.data
          this.$store.state.HC_workyearAndLevel = res.data.data
        }else{
          this.data = this.$store.state.HC_workyearAndLevel
        }
        /*
        res.data.data.workAge//工龄{desc:'标签',type:'值'}
        res.data.data.proficiency//专业职级{desc:'标签',type:'值'}
        res.data.data.isHealth//健康证明
        res.data.data.age//年龄
        */
      },
      /** @name 搜索单项 */
      send(obj,key){
        if(key)obj.key=key;
        //替换搜索项
        let type=-1;
        this.$parent.$refs.screen.workyearAndLevel.map((d,i)=>{
          if(d.key==key){
            type=i
          }
        });
        if(type>-1) {
          this.$parent.$refs.screen.workyearAndLevel.splice(type,1,obj)
          return
        }
        //添加搜索项
        this.$parent.$refs.screen.workyearAndLevel.push(obj)
      },
      /** @name 清队单项 */
      close(item){
        this.formData[item.key]=''
      },
      /** @name 清空所有 */
      closeall(){
        this.formData={
          workyear:'',
          level:''
        }
      }
    },
	}
</script>

<style scoped>

</style>
